class BaseModel {

    static needCheck(type) {
    }

    static check(obj, type) {
        obj = obj || new this();
        let needCheckData = this.needCheck(type);
        let needCheckKey = Object.keys(needCheckData);
        for (let key of needCheckKey) {
            if (!obj[key] || (needCheckData[key]['length'] && needCheckData[key]['length'] < obj[key].length)) {
                if (typeof obj[key] == "number" && obj[key] == 0) continue;
                else return needCheckData[key]['title'];
            } else if (obj[key] instanceof Array && !obj[key].length) {
                return needCheckData[key]['title'];
            }
            if (needCheckData[key]['minSize']) {
                if (!obj[key] && typeof obj[key] != "number") return needCheckData[key]['title'];
                if (obj[key] && needCheckData[key]['minSize'] > obj[key].length) {
                    return needCheckData[key]['title'];
                }
            }
        }
        return null;
    }

    //去掉object 变量的下划线
    static delDownslide(object, toObject) {
        let obj = toObject || {};
        let keys = Object.keys(object);
        keys.forEach(key => {
            if (toObject) {
                obj.__lookupSetter__(this.addOrDelDownslide(false, key)) && obj.__lookupSetter__(this.addOrDelDownslide(false, key)).call(obj, object[key]);
            } else {
                obj[this.addOrDelDownslide(false, key)] = object[key];
            }
        });
        if (toObject) {
            return this.delDownslide(obj);
        }
        return obj;
    }

    static addOrDelDownslide(isAdd, key) {
        if (isAdd && !key.indexOf('_') == 0) {
            return "_" + key;
        }
        if (!isAdd && key.indexOf('_') == 0) {
            return key.substr(1, key.length);
        }
        return key;
    }
}

module.exports = BaseModel;


// WEBPACK FOOTER //
// ./src/utils/baseModel.js